import { React, useState, useMemo } from "react";
import { Flex, MNotification, X } from "@cisco/spaces-dash-lib-styleguide";
import { NotificationContext } from "../contexts/notificationContext";

export default function (props) {
  const { children } = props;
  const [toast, setToast] = useState(null);
  const [status, setStatus] = useState("informational");
  const MIN_DURATION = 0;
  const MAX_DURATION = 10000;

  const setToastMessage = (message, duration = 5000, type = "") => {
    if (typeof duration !== "number") {
      return;
    }
    const adjustedDuration = Math.min(Math.max(duration, MIN_DURATION), MAX_DURATION);
    setToast(message);

    switch (type.toLowerCase()) {
      case "positive":
        setStatus("positive");
        break;

      case "negative":
        setStatus("negative");
        break;

      case "warning":
        setStatus("warning");
        break;

      default:
        setStatus("informational");
        break;
    }
    setTimeout(() => {
      setToast(null);
      setStatus("informational");
    }, adjustedDuration);
  };

  const closeToast = () => {
    setToast(null);
  };

  const contextValue = useMemo(() => ({ setToastMessage }), [setToastMessage]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {toast && (
        <Flex
          direction="vertical"
          gap={36}
          align="flex-end"
          style={{
            position: "absolute",
            zIndex: 999999999,
            right: 10,
            top: 66
          }}
        >
          <MNotification
            banner
            style={{
              width: 400
            }}
            status={status}
          >
            <Flex gap={4}>
              <Flex grow>{toast}</Flex>
              <X style={{ minWidth: "24px", cursor: "pointer" }} onClick={closeToast} />
            </Flex>
          </MNotification>
        </Flex>
      )}
      {children}
    </NotificationContext.Provider>
  );
}
